<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>关于我们</h3>
          <ul>
            <li><router-link to="/about">律所简介</router-link></li>
            <li><router-link to="/about">荣誉奖励</router-link></li>
            <li><router-link to="/about">文化理念</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>专业领域</h3>
          <ul>
            <li><router-link to="/practice-areas">劳动法</router-link></li>
            <li><router-link to="/practice-areas">公司业务</router-link></li>
            <li><router-link to="/practice-areas">争议解决</router-link></li>
            <li><router-link to="/practice-areas">刑事辩护</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>联系我们</h3>
          <ul>
            <li>电话：150-1010-6098</li>
            <li>邮箱：15010106098@163.com</li>
            <li>地址：北京市朝阳区东大桥路8号院1号尚都国际中心A座20层2021</li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>关注我们</h3>
          <div class="social-links">
            <a href="#" class="social-icon">微信</a>
            <a href="#" class="social-icon">微博</a>
            <a href="#" class="social-icon">LinkedIn</a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright-info">
          <p class="copyright-text">
            Copyright © 2024-2029  All Rights Reserved  版权所有·
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">京ICP备2026004269号</a>
             北京拓问律师事务所
          </p>
        </div>
        <div class="footer-links">
          <router-link to="/legal">法律声明</router-link>
          <span>|</span>
          <router-link to="/privacy">隐私政策</router-link>
          <span>|</span>
          <router-link to="/sitemap">网站地图</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: #1a1a1a;
  color: #fff;
  margin-top: auto;
  padding: 60px 0 20px;
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #fff;
}

.footer-section ul {
  list-style: none;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section a:hover {
  color: #667eea;
  padding-left: 5px;
  transition: all 0.3s ease;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-icon {
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 14px;
  display: inline-block;
}

.social-icon:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.3), rgba(118, 75, 162, 0.3));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.copyright-info {
  display: flex;
  align-items: center;
}

.copyright-text {
  color: #999;
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
  letter-spacing: 0.1px;
  white-space: nowrap;
}

.copyright-text .beian-link {
  color: #999;
  text-decoration: none;
  transition: color 0.3s;
}

.copyright-text .beian-link:hover {
  color: #ccc;
  text-decoration: underline;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #999;
}

.footer-links span {
  color: #999;
  margin: 0 4px;
  font-size: 13px;
}

.footer-links a {
  color: #999;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #ccc;
}

@media (max-width: 768px) {
  .footer {
    padding: 50px 0 20px;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
    margin-bottom: 30px;
  }
  
  .footer-bottom {
    flex-direction: column;
    text-align: center;
    gap: 20px;
    align-items: center;
  }
  
  .copyright-info {
    align-items: center;
    width: 100%;
  }
  
  .copyright-text {
    white-space: normal;
    text-align: center;
  }
  
  .footer-links {
    justify-content: center;
    width: 100%;
  }
}
</style>

